import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type TextContent } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesText, validationSchemaText } from "./TextCommon"
import TextForm from "./TextForm"
import { useCreateText } from "../../hooks/texts"

export default function TextCreate() {
  const createText = useCreateText()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesText(), [])
  const validationSchema = useMemo(() => validationSchemaText(), [])

  useBreadcrumbs([{ label: "Testi", href: "/text-contents/text-contents" }, { label: "Nuovo testo" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo testo</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createText.mutateAsync(values as TextContent).then(() => {
                navigate(`/text-contents/text-contents/`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TextForm />
                </Container>
                <BottomFormFixed url="/text-contents/text-contents" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
